import { IllustrationSvg, type IllustrationSvgProps } from './IllustrationSvg';
import { illustrationIdPrefix, pathHash, normalizeIllustrationPath } from './illustrationUtils';
import { renderMotifLayers, resolveMotifsFromPath } from './illustrationMotifs';

type LeafIllustrationProps = Omit<IllustrationSvgProps, 'idPrefix' | 'children'>;

/** Parametric theme-aware hero art for leaf and deep marketing paths. */
export function LeafHeroIllustration({ path, ...props }: LeafIllustrationProps & { path: string }) {
  const normalized = normalizeIllustrationPath(path);
  const motifs = resolveMotifsFromPath(normalized);
  const variant = pathHash(normalized) % 8;
  const idPrefix = illustrationIdPrefix(normalized);
  const gradId = `${idPrefix}-grad`;

  return (
    <IllustrationSvg idPrefix={idPrefix} {...props}>
      {renderMotifLayers(motifs, variant, gradId)}
    </IllustrationSvg>
  );
}
